function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* eslint-disable max-lines */
import { AddBillLarge } from './assets/AddBillLarge';
import { AddBillSmall } from './assets/AddBillSmall';
import { AddLarge } from './assets/AddLarge';
import { AddSmall } from './assets/AddSmall';
import { AiFraudDidectionLarge } from './assets/AiFraudDidectionLarge';
import { AiFraudDidectionSmall } from './assets/AiFraudDidectionSmall';
import { ApprovalLarge } from './assets/ApprovalLarge';
import { ApprovalSmall } from './assets/ApprovalSmall';
import { ApprovalWorkflowLarge } from './assets/ApprovalWorkflowLarge';
import { ApprovalWorkflowSmall } from './assets/ApprovalWorkflowSmall';
import { ArrowDownLarge } from './assets/ArrowDownLarge';
import { ArrowDownSmall } from './assets/ArrowDownSmall';
import { ArrowLeftLarge } from './assets/ArrowLeftLarge';
import { ArrowLeftSmall } from './assets/ArrowLeftSmall';
import { ArrowRightLarge } from './assets/ArrowRightLarge';
import { ArrowRightSmall } from './assets/ArrowRightSmall';
import { ArrowUpLarge } from './assets/ArrowUpLarge';
import { ArrowUpSmall } from './assets/ArrowUpSmall';
import { AttachmentLarge } from './assets/AttachmentLarge';
import { AttachmentSmall } from './assets/AttachmentSmall';
import { AudioLarge } from './assets/AudioLarge';
import { AudioSmall } from './assets/AudioSmall';
import { BankInLarge } from './assets/BankInLarge';
import { BankInSmall } from './assets/BankInSmall';
import { BankLarge } from './assets/BankLarge';
import { BankOutLarge } from './assets/BankOutLarge';
import { BankOutSmall } from './assets/BankOutSmall';
import { BankSmall } from './assets/BankSmall';
import { BillingSettingsLarge } from './assets/BillingSettingsLarge';
import { BillingSettingsSmall } from './assets/BillingSettingsSmall';
import { BillsLarge } from './assets/BillsLarge';
import { BillsSmall } from './assets/BillsSmall';
import { CalculatorLarge } from './assets/CalculatorLarge';
import { CalculatorSmall } from './assets/CalculatorSmall';
import { CalendarLarge } from './assets/CalendarLarge';
import { CalendarMoveLarge } from './assets/CalendarMoveLarge';
import { CalendarMoveSmall } from './assets/CalendarMoveSmall';
import { CalendarSmall } from './assets/CalendarSmall';
import { CameraLarge } from './assets/CameraLarge';
import { CameraSmall } from './assets/CameraSmall';
import { CancelCircleFillLarge } from './assets/CancelCircleFillLarge';
import { CancelCircleFillSmall } from './assets/CancelCircleFillSmall';
import { CancelCircleLarge } from './assets/CancelCircleLarge';
import { CancelCircleSmall } from './assets/CancelCircleSmall';
import { CaretDownLarge } from './assets/CaretDownLarge';
import { CaretDownSmall } from './assets/CaretDownSmall';
import { CaretLeftLarge } from './assets/CaretLeftLarge';
import { CaretLeftSmall } from './assets/CaretLeftSmall';
import { CaretRightLarge } from './assets/CaretRightLarge';
import { CaretRightSmall } from './assets/CaretRightSmall';
import { CaretUpLarge } from './assets/CaretUpLarge';
import { CaretUpSmall } from './assets/CaretUpSmall';
import { ChatEmptyLarge } from './assets/ChatEmptyLarge';
import { ChatEmptySmall } from './assets/ChatEmptySmall';
import { ChatLarge } from './assets/ChatLarge';
import { ChatSmall } from './assets/ChatSmall';
import { CheckedCircleFillLarge } from './assets/CheckedCircleFillLarge';
import { CheckedCircleFillSmall } from './assets/CheckedCircleFillSmall';
import { CheckedCircleLarge } from './assets/CheckedCircleLarge';
import { CheckedCircleSmall } from './assets/CheckedCircleSmall';
import { CheckedDoubleLarge } from './assets/CheckedDoubleLarge';
import { CheckedDoubleSmall } from './assets/CheckedDoubleSmall';
import { CheckedLarge } from './assets/CheckedLarge';
import { CheckedMini } from './assets/CheckedMini';
import { CheckedSmall } from './assets/CheckedSmall';
import { ChevronDownLarge } from './assets/ChevronDownLarge';
import { ChevronDownSmall } from './assets/ChevronDownSmall';
import { ChevronLeftLarge } from './assets/ChevronLeftLarge';
import { ChevronLeftSmall } from './assets/ChevronLeftSmall';
import { ChevronRightLarge } from './assets/ChevronRightLarge';
import { ChevronRightSmall } from './assets/ChevronRightSmall';
import { ChevronUpLarge } from './assets/ChevronUpLarge';
import { ChevronUpSmall } from './assets/ChevronUpSmall';
import { CloseLarge } from './assets/CloseLarge';
import { CloseMiniLarge } from './assets/CloseMiniLarge';
import { CloseMiniSmall } from './assets/CloseMiniSmall';
import { CloseSmall } from './assets/CloseSmall';
import { CompanyLarge } from './assets/CompanyLarge';
import { CompanySmall } from './assets/CompanySmall';
import { ComposeLarge } from './assets/ComposeLarge';
import { ComposeSmall } from './assets/ComposeSmall';
import { ContactsLarge } from './assets/ContactsLarge';
import { ContactsSmall } from './assets/ContactsSmall';
import { CreditCardLarge } from './assets/CreditCardLarge';
import { CreditCardSmall } from './assets/CreditCardSmall';
import { CustomerLarge } from './assets/CustomerLarge';
import { CustomerSmall } from './assets/CustomerSmall';
import { DashboardLarge } from './assets/DashboardLarge';
import { DashboardSmall } from './assets/DashboardSmall';
import { DebitCardLarge } from './assets/DebitCardLarge';
import { DebitCardSmall } from './assets/DebitCardSmall';
import { DeclineCircleFillLarge } from './assets/DeclineCircleFillLarge';
import { DeclineCircleFillSmall } from './assets/DeclineCircleFillSmall';
import { DeclineCircleLarge } from './assets/DeclineCircleLarge';
import { DeclineCircleSmall } from './assets/DeclineCircleSmall';
import { DeleteLarge } from './assets/DeleteLarge';
import { DeleteSmall } from './assets/DeleteSmall';
import { DirectoryPaymentLarge } from './assets/DirectoryPaymentLarge';
import { DirectoryPaymentSmall } from './assets/DirectoryPaymentSmall';
import { DownloadLarge } from './assets/DownloadLarge';
import { DownloadSmall } from './assets/DownloadSmall';
import { DuplicateFlipLarge } from './assets/DuplicateFlipLarge';
import { DuplicateFlipSmall } from './assets/DuplicateFlipSmall';
import { DuplicateLarge } from './assets/DuplicateLarge';
import { DuplicateSmall } from './assets/DuplicateSmall';
import { EditLarge } from './assets/EditLarge';
import { EditSmall } from './assets/EditSmall';
import { EmailLarge } from './assets/EmailLarge';
import { EmailSmall } from './assets/EmailSmall';
import { ErrorCircleFillLarge } from './assets/ErrorCircleFillLarge';
import { ErrorCircleFillSmall } from './assets/ErrorCircleFillSmall';
import { ErrorCircleLarge } from './assets/ErrorCircleLarge';
import { ErrorCircleSmall } from './assets/ErrorCircleSmall';
import { ExitLarge } from './assets/ExitLarge';
import { ExitSmall } from './assets/ExitSmall';
import { FastLarge } from './assets/FastLarge';
import { FastSmall } from './assets/FastSmall';
import { FavouriteLarge } from './assets/FavouriteLarge';
import { FavouriteSmall } from './assets/FavouriteSmall';
import { FileAddLarge } from './assets/FileAddLarge';
import { FileAddSmall } from './assets/FileAddSmall';
import { FileMoveLarge } from './assets/FileMoveLarge';
import { FileMoveSmall } from './assets/FileMoveSmall';
import { FilterLarge } from './assets/FilterLarge';
import { FilterSmall } from './assets/FilterSmall';
import { flagsMap } from './assets/flags/flags.types';
import { FlowLarge } from './assets/FlowLarge';
import { FlowSmall } from './assets/FlowSmall';
import { GalleryLarge } from './assets/GalleryLarge';
import { GallerySmall } from './assets/GallerySmall';
import { GetPaidLarge } from './assets/GetPaidLarge';
import { GetPaidSmall } from './assets/GetPaidSmall';
import { GetStartedLarge } from './assets/GetStartedLarge';
import { GetStartedSmall } from './assets/GetStartedSmall';
import { GlassesLarge } from './assets/GlassesLarge';
import { GlassesSmall } from './assets/GlassesSmall';
import { HelpCircleFillLarge } from './assets/HelpCircleFillLarge';
import { HelpCircleFillSmall } from './assets/HelpCircleFillSmall';
import { HelpCircleLarge } from './assets/HelpCircleLarge';
import { HelpCircleSmall } from './assets/HelpCircleSmall';
import { HideLarge } from './assets/HideLarge';
import { HideSmall } from './assets/HideSmall';
import { IframeLarge } from './assets/IframeLarge';
import { IframeSmall } from './assets/IframeSmall';
import { ImageAddLarge } from './assets/ImageAddLarge';
import { ImageAddSmall } from './assets/ImageAddSmall';
import { InfoCircleFillLarge } from './assets/InfoCircleFillLarge';
import { InfoCircleFillSmall } from './assets/InfoCircleFillSmall';
import { InfoCircleLarge } from './assets/InfoCircleLarge';
import { InfoCircleSmall } from './assets/InfoCircleSmall';
import { InstallLarge } from './assets/InstallLarge';
import { InstallmentsLarge } from './assets/InstallmentsLarge';
import { InstallmentsSmall } from './assets/InstallmentsSmall';
import { InstallSmall } from './assets/InstallSmall';
import { InternationalLarge } from './assets/InternationalLarge';
import { InternationalSmall } from './assets/InternationalSmall';
import { InvoicesLarge } from './assets/InvoicesLarge';
import { InvoicesSmall } from './assets/InvoicesSmall';
import { LaptopLarge } from './assets/LaptopLarge';
import { LaptopSmall } from './assets/LaptopSmall';
import { LinkCircleFillLarge } from './assets/LinkCircleFillLarge';
import { LinkCircleFillSmall } from './assets/LinkCircleFillSmall';
import { LinkOpenLarge } from './assets/LinkOpenLarge';
import { LinkOpenSmall } from './assets/LinkOpenSmall';
import { LockLarge } from './assets/LockLarge';
import { LockSmall } from './assets/LockSmall';
import { MailInboxLarge } from './assets/MailInboxLarge';
import { MailInboxSmall } from './assets/MailInboxSmall';
import { MenuLarge } from './assets/MenuLarge';
import { MenuSmall } from './assets/MenuSmall';
import { MobileLarge } from './assets/MobileLarge';
import { MobileSmall } from './assets/MobileSmall';
import { MoneyPaymentLarge } from './assets/MoneyPaymentLarge';
import { MoneyPaymentSmall } from './assets/MoneyPaymentSmall';
import { MoneyReceiveLarge } from './assets/MoneyReceiveLarge';
import { MoneyReceiveSmall } from './assets/MoneyReceiveSmall';
import { MonitorLarge } from './assets/MonitorLarge';
import { MonitorSmall } from './assets/MonitorSmall';
import { More } from './assets/More';
import { MoreVertical } from './assets/MoreVertical';
import { MoreVerticalAlignedLeft } from './assets/MoreVerticalAlignedLeft';
import { MultiCompanyLarge } from './assets/MultiCompanyLarge';
import { MultiCompanySmall } from './assets/MultiCompanySmall';
import { MultipuleApprovalLarge } from './assets/MultipuleApprovalLarge';
import { MultipuleApprovalSmall } from './assets/MultipuleApprovalSmall';
import { MultiUseCardLarge } from './assets/MultiUseCardLarge';
import { MultiUseCardSmall } from './assets/MultiUseCardSmall';
import { NoBillsLarge } from './assets/NoBillsLarge';
import { NoBillsSmall } from './assets/NoBillsSmall';
import { NoteAddLarge } from './assets/NoteAddLarge';
import { NoteAddSmall } from './assets/NoteAddSmall';
import { NotificationLarge } from './assets/NotificationLarge';
import { NotificationSmall } from './assets/NotificationSmall';
import { PaperCheckLarge } from './assets/PaperCheckLarge';
import { PaperCheckSmall } from './assets/PaperCheckSmall';
import { PathLarge } from './assets/PathLarge';
import { PathSmall } from './assets/PathSmall';
import { PauseCircleFillLarge } from './assets/PauseCircleFillLarge';
import { PauseCircleFillSmall } from './assets/PauseCircleFillSmall';
import { PauseCircleLarge } from './assets/PauseCircleLarge';
import { PauseCircleSmall } from './assets/PauseCircleSmall';
import { PauseLarge } from './assets/PauseLarge';
import { PauseSmall } from './assets/PauseSmall';
import { PauseSolidLarge } from './assets/PauseSolidLarge';
import { PayLarge } from './assets/PayLarge';
import { PaymentsLarge } from './assets/PaymentsLarge';
import { PaymentsSmall } from './assets/PaymentsSmall';
import { PaySmall } from './assets/PaySmall';
import { PhoneLarge } from './assets/PhoneLarge';
import { PhoneSmall } from './assets/PhoneSmall';
import { PlayLarge } from './assets/PlayLarge';
import { PlaySmall } from './assets/PlaySmall';
import { PrintLarge } from './assets/PrintLarge';
import { PrintSmall } from './assets/PrintSmall';
import { ProcessFillLarge } from './assets/ProcessFillLarge';
import { ProcessFillSmall } from './assets/ProcessFillSmall';
import { ProcessLarge } from './assets/ProcessLarge';
import { ProcessSmall } from './assets/ProcessSmall';
import { PromoteLarge } from './assets/PromoteLarge';
import { PromoteSmall } from './assets/PromoteSmall';
import { ProtectionLarge } from './assets/ProtectionLarge';
import { ProtectionSmall } from './assets/ProtectionSmall';
import { QrCodeLarge } from './assets/QrCodeLarge';
import { QrCodeSmall } from './assets/QrCodeSmall';
import { RefreshCircleFillLarge } from './assets/RefreshCircleFillLarge';
import { RefreshCircleFillSmall } from './assets/RefreshCircleFillSmall';
import { RefreshLarge } from './assets/RefreshLarge';
import { RefreshSmall } from './assets/RefreshSmall';
import { RemoveLarge } from './assets/RemoveLarge';
import { RemoveSmall } from './assets/RemoveSmall';
import { RepeatLarge } from './assets/RepeatLarge';
import { RepeatSmall } from './assets/RepeatSmall';
import { ScheduledLarge } from './assets/ScheduledLarge';
import { ScheduledSmall } from './assets/ScheduledSmall';
import { SearchLarge } from './assets/SearchLarge';
import { SearchSmall } from './assets/SearchSmall';
import { SendLarge } from './assets/SendLarge';
import { SendSmall } from './assets/SendSmall';
import { SettingsLarge } from './assets/SettingsLarge';
import { SettingsSmall } from './assets/SettingsSmall';
import { ShareLarge } from './assets/ShareLarge';
import { ShareSmall } from './assets/ShareSmall';
import { ShieldLarge } from './assets/ShieldLarge';
import { ShieldSmall } from './assets/ShieldSmall';
import { ShipLarge } from './assets/ShipLarge';
import { ShipSmall } from './assets/ShipSmall';
import { ShopLarge } from './assets/ShopLarge';
import { ShopSmall } from './assets/ShopSmall';
import { ShowLarge } from './assets/ShowLarge';
import { ShowSmall } from './assets/ShowSmall';
import { SingleUseCardLarge } from './assets/SingleUseCardLarge';
import { SingleUseCardSmall } from './assets/SingleUseCardSmall';
import { SoftwareSyncLarge } from './assets/SoftwareSyncLarge';
import { SoftwareSyncSmall } from './assets/SoftwareSyncSmall';
import { SortLarge } from './assets/SortLarge';
import { SortSmall } from './assets/SortSmall';
import { StopwatchFastLarge } from './assets/StopwatchFastLarge';
import { StopwatchFastSmall } from './assets/StopwatchFastSmall';
import { StopwatchFillLarge } from './assets/StopwatchFillLarge';
import { StopwatchFillSmall } from './assets/StopwatchFillSmall';
import { StopwatchLarge } from './assets/StopwatchLarge';
import { StopwatchSmall } from './assets/StopwatchSmall';
import { SubArrowLarge } from './assets/SubArrowLarge';
import { SubArrowSmall } from './assets/SubArrowSmall';
import { TabletEditLarge } from './assets/TabletEditLarge';
import { TabletEditSmall } from './assets/TabletEditSmall';
import { TabletSearchLarge } from './assets/TabletSearchLarge';
import { TabletSearchSmall } from './assets/TabletSearchSmall';
import { TeamLarge } from './assets/TeamLarge';
import { TeamSmall } from './assets/TeamSmall';
import { TrackLarge } from './assets/TrackLarge';
import { TrackSmall } from './assets/TrackSmall';
import { UploadLarge } from './assets/UploadLarge';
import { UploadSmall } from './assets/UploadSmall';
import { UserAddLarge } from './assets/UserAddLarge';
import { UserAddSmall } from './assets/UserAddSmall';
import { UserCheckLarge } from './assets/UserCheckLarge';
import { UserCheckSmall } from './assets/UserCheckSmall';
import { UserIdLarge } from './assets/UserIdLarge';
import { UserIdSmall } from './assets/UserIdSmall';
import { UserLarge } from './assets/UserLarge';
import { UserRemoveLarge } from './assets/UserRemoveLarge';
import { UserRemoveSmall } from './assets/UserRemoveSmall';
import { UserSmall } from './assets/UserSmall';
import { VendorLarge } from './assets/VendorLarge';
import { VendorSmall } from './assets/VendorSmall';
import { VerifiedLarge } from './assets/VerifiedLarge';
import { VerifiedSmall } from './assets/VerifiedSmall';
import { VideoLarge } from './assets/VideoLarge';
import { VideoSmall } from './assets/VideoSmall';
import { WalletLarge } from './assets/WalletLarge';
import { WalletSmall } from './assets/WalletSmall';
import { WarningFillLarge } from './assets/WarningFillLarge';
import { WarningFillSmall } from './assets/WarningFillSmall';
import { WarningLarge } from './assets/WarningLarge';
import { WarningSmall } from './assets/WarningSmall';
import { WarningSolidLarge } from './assets/WarningSolidLarge';
import { WhiteLabelLarge } from './assets/WhiteLabelLarge';
import { WhiteLabelSmall } from './assets/WhiteLabelSmall';
import { WireTransferLarge } from './assets/WireTransferLarge';
import { WireTransferSmall } from './assets/WireTransferSmall';
import { _brandFullInvertedMap, _brandFullMap, _brandFullNeutralMap } from './brand';
import { _brandSymbolsInvertedMap, _brandSymbolsMap } from './brandSymbol';
var defaultIconsMap = {
  add: {
    small: AddSmall,
    medium: AddLarge
  },
  'add-bill': {
    small: AddBillSmall,
    medium: AddBillLarge
  },
  'ai-fraud-didection': {
    small: AiFraudDidectionSmall,
    medium: AiFraudDidectionLarge
  },
  approval: {
    small: ApprovalSmall,
    medium: ApprovalLarge
  },
  'approval-workflow': {
    small: ApprovalWorkflowSmall,
    medium: ApprovalWorkflowLarge
  },
  'arrow-down': {
    small: ArrowDownSmall,
    medium: ArrowDownLarge
  },
  'arrow-left': {
    small: ArrowLeftSmall,
    medium: ArrowLeftLarge
  },
  'arrow-right': {
    small: ArrowRightSmall,
    medium: ArrowRightLarge
  },
  'arrow-up': {
    small: ArrowUpSmall,
    medium: ArrowUpLarge
  },
  attachment: {
    small: AttachmentSmall,
    medium: AttachmentLarge
  },
  audio: {
    small: AudioSmall,
    medium: AudioLarge
  },
  bank: {
    small: BankSmall,
    medium: BankLarge
  },
  'bank-in': {
    small: BankInSmall,
    medium: BankInLarge
  },
  'bank-out': {
    small: BankOutSmall,
    medium: BankOutLarge
  },
  bills: {
    small: BillsSmall,
    medium: BillsLarge
  },
  'billing-settings': {
    small: BillingSettingsSmall,
    medium: BillingSettingsLarge
  },
  calculator: {
    small: CalculatorSmall,
    medium: CalculatorLarge
  },
  calendar: {
    small: CalendarSmall,
    medium: CalendarLarge
  },
  'calendar-move': {
    small: CalendarMoveSmall,
    medium: CalendarMoveLarge
  },
  camera: {
    small: CameraSmall,
    medium: CameraLarge
  },
  cancel: {
    small: CancelCircleFillSmall,
    medium: CancelCircleFillLarge
  },
  'cancel-circle': {
    small: CancelCircleSmall,
    medium: CancelCircleLarge
  },
  'caret-down': {
    small: CaretDownSmall,
    medium: CaretDownLarge
  },
  'caret-left': {
    small: CaretLeftSmall,
    medium: CaretLeftLarge
  },
  'caret-right': {
    small: CaretRightSmall,
    medium: CaretRightLarge
  },
  'caret-up': {
    small: CaretUpSmall,
    medium: CaretUpLarge
  },
  chat: {
    small: ChatSmall,
    medium: ChatLarge
  },
  'chat-empty': {
    small: ChatEmptySmall,
    medium: ChatEmptyLarge
  },
  checked: {
    small: CheckedSmall,
    medium: CheckedLarge
  },
  'checked-mini': CheckedMini,
  'checked-circle': {
    small: CheckedCircleSmall,
    medium: CheckedCircleLarge
  },
  'checked-circle-fill': {
    small: CheckedCircleFillSmall,
    medium: CheckedCircleFillLarge
  },
  'checked-double': {
    small: CheckedDoubleSmall,
    medium: CheckedDoubleLarge
  },
  'chevron-down': {
    small: ChevronDownSmall,
    medium: ChevronDownLarge
  },
  'chevron-left': {
    small: ChevronLeftSmall,
    medium: ChevronLeftLarge
  },
  'chevron-right': {
    small: ChevronRightSmall,
    medium: ChevronRightLarge
  },
  'chevron-up': {
    small: ChevronUpSmall,
    medium: ChevronUpLarge
  },
  close: {
    small: CloseSmall,
    medium: CloseLarge
  },
  'close-mini': {
    small: CloseMiniSmall,
    medium: CloseMiniLarge
  },
  company: {
    small: CompanySmall,
    medium: CompanyLarge
  },
  compose: {
    small: ComposeSmall,
    medium: ComposeLarge
  },
  contacts: {
    small: ContactsSmall,
    medium: ContactsLarge
  },
  'credit-card': {
    small: CreditCardSmall,
    medium: CreditCardLarge
  },
  customer: {
    small: CustomerSmall,
    medium: CustomerLarge
  },
  dashboard: {
    small: DashboardSmall,
    medium: DashboardLarge
  },
  'debit-card': {
    small: DebitCardSmall,
    medium: DebitCardLarge
  },
  decline: {
    small: DeclineCircleSmall,
    medium: DeclineCircleLarge
  },
  'decline-fill': {
    small: DeclineCircleFillSmall,
    medium: DeclineCircleFillLarge
  },
  delete: {
    small: DeleteSmall,
    medium: DeleteLarge
  },
  'directory-payment': {
    small: DirectoryPaymentSmall,
    medium: DirectoryPaymentLarge
  },
  download: {
    small: DownloadSmall,
    medium: DownloadLarge
  },
  duplicate: {
    small: DuplicateSmall,
    medium: DuplicateLarge
  },
  'duplicate-flip': {
    small: DuplicateFlipSmall,
    medium: DuplicateFlipLarge
  },
  edit: {
    small: EditSmall,
    medium: EditLarge
  },
  email: {
    small: EmailSmall,
    medium: EmailLarge
  },
  error: {
    small: ErrorCircleSmall,
    medium: ErrorCircleLarge
  },
  'error-fill': {
    small: ErrorCircleFillSmall,
    medium: ErrorCircleFillLarge
  },
  exit: {
    small: ExitSmall,
    medium: ExitLarge
  },
  fast: {
    small: FastSmall,
    medium: FastLarge
  },
  favourite: {
    small: FavouriteSmall,
    medium: FavouriteLarge
  },
  'file-add': {
    small: FileAddSmall,
    medium: FileAddLarge
  },
  'file-move': {
    small: FileMoveSmall,
    medium: FileMoveLarge
  },
  filter: {
    small: FilterSmall,
    medium: FilterLarge
  },
  flow: {
    small: FlowSmall,
    medium: FlowLarge
  },
  gallery: {
    small: GallerySmall,
    medium: GalleryLarge
  },
  'get-paid': {
    small: GetPaidSmall,
    medium: GetPaidLarge
  },
  'get-started': {
    small: GetStartedSmall,
    medium: GetStartedLarge
  },
  glasses: {
    small: GlassesSmall,
    medium: GlassesLarge
  },
  'help-circle': {
    small: HelpCircleSmall,
    medium: HelpCircleLarge
  },
  'help-circle-fill': {
    small: HelpCircleFillSmall,
    medium: HelpCircleFillLarge
  },
  hide: {
    small: HideSmall,
    medium: HideLarge
  },
  iframe: {
    small: IframeSmall,
    medium: IframeLarge
  },
  'image-add': {
    small: ImageAddSmall,
    medium: ImageAddLarge
  },
  install: {
    small: InstallSmall,
    medium: InstallLarge
  },
  installments: {
    small: InstallmentsSmall,
    medium: InstallmentsLarge
  },
  info: {
    small: InfoCircleSmall,
    medium: InfoCircleLarge
  },
  'info-fill': {
    small: InfoCircleFillSmall,
    medium: InfoCircleFillLarge
  },
  international: {
    small: InternationalSmall,
    medium: InternationalLarge
  },
  invoices: {
    small: InvoicesSmall,
    medium: InvoicesLarge
  },
  laptop: {
    small: LaptopSmall,
    medium: LaptopLarge
  },
  'link-fill': {
    small: LinkCircleFillSmall,
    medium: LinkCircleFillLarge
  },
  'link-open': {
    small: LinkOpenSmall,
    medium: LinkOpenLarge
  },
  lock: {
    small: LockSmall,
    medium: LockLarge
  },
  'mail-inbox': {
    small: MailInboxSmall,
    medium: MailInboxLarge
  },
  menu: {
    small: MenuSmall,
    medium: MenuLarge
  },
  mobile: {
    small: MobileSmall,
    medium: MobileLarge
  },
  monitor: {
    small: MonitorSmall,
    medium: MonitorLarge
  },
  'money-payment': {
    small: MoneyPaymentSmall,
    medium: MoneyPaymentLarge
  },
  'money-receive': {
    small: MoneyReceiveSmall,
    medium: MoneyReceiveLarge
  },
  more: More,
  'more-vertical': MoreVertical,
  'more-vertical-aligned-left': MoreVerticalAlignedLeft,
  'multi-use-card': {
    small: MultiUseCardSmall,
    medium: MultiUseCardLarge
  },
  'no-bills': {
    small: NoBillsSmall,
    medium: NoBillsLarge
  },
  'note-add': {
    small: NoteAddSmall,
    medium: NoteAddLarge
  },
  notification: {
    small: NotificationSmall,
    medium: NotificationLarge
  },
  'multipule-approval': {
    small: MultipuleApprovalSmall,
    medium: MultipuleApprovalLarge
  },
  'paper-check': {
    small: PaperCheckSmall,
    medium: PaperCheckLarge
  },
  path: {
    small: PathSmall,
    medium: PathLarge
  },
  pause: {
    small: PauseSmall,
    medium: PauseLarge
  },
  'pause-circle': {
    small: PauseCircleSmall,
    medium: PauseCircleLarge
  },
  'pause-fill': {
    small: PauseCircleFillSmall,
    medium: PauseCircleFillLarge
  },
  pay: {
    small: PaySmall,
    medium: PayLarge
  },
  payments: {
    small: PaymentsSmall,
    medium: PaymentsLarge
  },
  'pause-solid': PauseSolidLarge,
  phone: {
    small: PhoneSmall,
    medium: PhoneLarge
  },
  play: {
    small: PlaySmall,
    medium: PlayLarge
  },
  print: {
    small: PrintSmall,
    medium: PrintLarge
  },
  process: {
    small: ProcessSmall,
    medium: ProcessLarge
  },
  'process-fill': {
    small: ProcessFillSmall,
    medium: ProcessFillLarge
  },
  promote: {
    small: PromoteSmall,
    medium: PromoteLarge
  },
  protection: {
    small: ProtectionSmall,
    medium: ProtectionLarge
  },
  'qr-code': {
    small: QrCodeSmall,
    medium: QrCodeLarge
  },
  refresh: {
    small: RefreshSmall,
    medium: RefreshLarge
  },
  'refresh-fill': {
    small: RefreshCircleFillSmall,
    medium: RefreshCircleFillLarge
  },
  repeat: {
    small: RepeatSmall,
    medium: RepeatLarge
  },
  remove: {
    small: RemoveSmall,
    medium: RemoveLarge
  },
  scheduled: {
    small: ScheduledSmall,
    medium: ScheduledLarge
  },
  search: {
    small: SearchSmall,
    medium: SearchLarge
  },
  send: {
    small: SendSmall,
    medium: SendLarge
  },
  settings: {
    small: SettingsSmall,
    medium: SettingsLarge
  },
  share: {
    small: ShareSmall,
    medium: ShareLarge
  },
  shield: {
    small: ShieldSmall,
    medium: ShieldLarge
  },
  ship: {
    small: ShipSmall,
    medium: ShipLarge
  },
  shop: {
    small: ShopSmall,
    medium: ShopLarge
  },
  show: {
    small: ShowSmall,
    medium: ShowLarge
  },
  'single-use-card': {
    small: SingleUseCardSmall,
    medium: SingleUseCardLarge
  },
  'software-sync': {
    small: SoftwareSyncSmall,
    medium: SoftwareSyncLarge
  },
  sort: {
    small: SortSmall,
    medium: SortLarge
  },
  stopwatch: {
    small: StopwatchSmall,
    medium: StopwatchLarge
  },
  'stopwatch-fast': {
    small: StopwatchFastSmall,
    medium: StopwatchFastLarge
  },
  'stopwatch-fill': {
    small: StopwatchFillSmall,
    medium: StopwatchFillLarge
  },
  'sub-arrow': {
    small: SubArrowSmall,
    medium: SubArrowLarge
  },
  'tablet-edit': {
    small: TabletEditSmall,
    medium: TabletEditLarge
  },
  'tablet-search': {
    small: TabletSearchSmall,
    medium: TabletSearchLarge
  },
  team: {
    small: TeamSmall,
    medium: TeamLarge
  },
  track: {
    small: TrackSmall,
    medium: TrackLarge
  },
  upload: {
    small: UploadSmall,
    medium: UploadLarge
  },
  user: {
    small: UserSmall,
    medium: UserLarge
  },
  'user-add': {
    small: UserAddSmall,
    medium: UserAddLarge
  },
  'user-check': {
    small: UserCheckSmall,
    medium: UserCheckLarge
  },
  'user-id': {
    small: UserIdSmall,
    medium: UserIdLarge
  },
  'user-remove': {
    small: UserRemoveSmall,
    medium: UserRemoveLarge
  },
  vendor: {
    small: VendorSmall,
    medium: VendorLarge
  },
  verified: {
    small: VerifiedSmall,
    medium: VerifiedLarge
  },
  video: {
    small: VideoSmall,
    medium: VideoLarge
  },
  wallet: {
    small: WalletSmall,
    medium: WalletLarge
  },
  warning: {
    small: WarningSmall,
    medium: WarningLarge
  },
  'warning-fill': {
    small: WarningFillSmall,
    medium: WarningFillLarge
  },
  'warning-solid': WarningSolidLarge,
  'white-label': {
    small: WhiteLabelSmall,
    medium: WhiteLabelLarge
  },
  'wire-transfer': {
    small: WireTransferSmall,
    medium: WireTransferLarge
  },
  'multi-company': {
    small: MultiCompanySmall,
    medium: MultiCompanyLarge
  }
};
export var allIcons = _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, defaultIconsMap), _brandSymbolsMap), _brandSymbolsInvertedMap), _brandFullMap), _brandFullNeutralMap), _brandFullInvertedMap), flagsMap);
export var icons = defaultIconsMap;
//# sourceMappingURL=icons.js.map